const CHAT_KEY = 'chat_messages';

export function saveChatToLocal(messages: { role: 'user' | 'assistant'; content: string }[]) {
  localStorage.setItem(CHAT_KEY, JSON.stringify(messages));
}

export function loadChatFromLocal(): { role: 'user' | 'assistant'; content: string }[] {
  const raw = localStorage.getItem(CHAT_KEY);
  if (!raw) return [];
  try {
    const all = JSON.parse(raw);
    return all.slice(-10); // 返回最近 10 条
  } catch {
    return [];
  }
}

export function clearChatLocal() {
  localStorage.removeItem(CHAT_KEY);
}
